import { type FC } from 'react';

import { specContractList } from '@/common/constants/contract';
import { type MainPageContractTabs } from '@/common/types/contract';
import { ActiveSpecContractItem } from '@/components/Contract/ActiveSpecContractItem/ActiveSpecContractItem';
import { selectSortedAvailableSpecContract } from '@/redux/selectors/contractSelectors';
import { useAppSelector } from '@/redux/store';

interface ActiveSpecContractListProps {
  tab: MainPageContractTabs;
}

const ActiveSpecContractList: FC<ActiveSpecContractListProps> = ({ tab }) => {
  const isFirstVisit = useAppSelector((state) => state.user.isFirstVisit);
  const availableContractList = useAppSelector((state) =>
    selectSortedAvailableSpecContract(state, specContractList, tab),
  );

  return (
    !isFirstVisit &&
    availableContractList.map((contract) => (
      <ActiveSpecContractItem key={contract.id} {...contract} />
    ))
  );
};

export { ActiveSpecContractList };
